export default "__VITE_ASSET__B2gq727d__"